<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('cms_view')"/>
            </div>
        </div>           

        <div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Title:</label>
                  <p>{{cms.title}}</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Sub Title:</label>
                  <p>{{cms.sub_title}}</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Description</label>
                  <p>{{cms.description}}</p>
                </div>
              </div>
            </div>
     </div>      
    </div>
</template>

<script>
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin"; 
    import * as actions from '../../../../Config/ApiUrl';
    export default {
        name: "ViewCMS",
        mixins: [FormMixin],
        data(){
        return {
          cms: {},
          }
        },
    }
</script>